var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:_vm.$style['app-aside-nav__item']},[_c('RouterLink',{directives:[{name:"testid",rawName:"v-testid",value:(`nav-item-${_vm.route.path.replace(/^\//, '')}`),expression:"`nav-item-${route.path.replace(/^\\//, '')}`"}],class:[
			_vm.$style['app-aside-nav__link'],
			{
				[_vm.$style['app-aside-nav__link--open']]: _vm.status === 'open',
				[_vm.$style['app-aside-nav__link--active']]: _vm.isActive
			}
		],attrs:{"to":_vm.to,"active-class":_vm.$style['app-aside-nav__link--active']}},[_c('BaseIconButton',{class:_vm.$style['app-aside-nav__link-icon'],attrs:{"with-ripple":false}},[_c('FontAwesomeIcon',{attrs:{"icon":_vm.icon,"size":"lg"}})],1),_vm._v(" "+_vm._s(_vm.$tc(`common.titles.${_vm.route.meta.displayName}`, 2))+" ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }